import { gql } from '@apollo/client';

export const REMOVE_TICKET_FROM_INCIDENT = gql`
mutation removeTicketFromIncident($input: RemoveTicketFromIncidentInput!) {
  removeTicketFromIncident(input: $input) {
    __typename
    clientMutationId
    errors
    ticketUuid
  }
}
`
